import { useState, useEffect } from 'react';

const BackToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const heroSection = document.getElementById('hero');
    
    if (!heroSection) return;

    // showing or hiding the back to top button based on if the Hero section is visible or not.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShowButton(false); 
          } else {
            setShowButton(true);
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    observer.observe(heroSection);

    return () => observer.disconnect();
  }, []);

  // Function to scroll back to the top.
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {showButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-emerald-600/20 hover:bg-emerald-400/40 text-white w-12 h-12 rounded-full shadow-lg transition-colors duration-200 z-50 flex items-center justify-center"
        >
          ↑
        </button>
      )}
    </>
  );
};

export default BackToTopButton;